enum Currency {
    DOLLAR = "DOLLAR",
    MN = "MN",
    MLC = "MLC",
    USD = "USD"
}

export default Currency;